import { Component } from '@angular/core';
import { AlertsList } from '../alerts-list/alerts-list';

@Component({
  selector: 'app-alerts-page',
  imports: [AlertsList],
  templateUrl: './alerts-page.html',
  styleUrl: './alerts-page.scss',
})
export class AlertsPage {}
